export default function NavUnread({ count }) {
  if (!count) return null;
  return (
    <span className="unread-pip" aria-label={`${count} unread`}>
      {count}
    </span>
  );
}
